import { inject, Injectable } from '@angular/core';

import { AuthStrategy } from '@generator-strategies/auth-strategy';

import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AppAuthStrategy extends AuthStrategy {
  private readonly authService = inject(AuthService);

  override async signOut(): Promise<void> {
    await this.authService.signOut();
  }
}
